import template from './resetSearch.html';

class ResetSearchController {
  constructor($location, savedSearchService, filtersService, analyticsService) {
    this.location = $location;
    this.savedSearchService = savedSearchService;
    this.buildQueryParams = filtersService.FilterSet.prototype.buildQueryParams;
    this.analytics = analyticsService;
  }

  resetSearch() {
    this.savedSearchService.getDefault()
      .then((defaultSearch) => {
        this.analytics.trackEvent('search management', 'reset search');

        if (defaultSearch) {
          const search = this.savedSearchService.processRawSearch(defaultSearch);
          const filters = this.savedSearchService.processDates(search);
          const params = this.buildQueryParams.call(this, filters);
          this.location.search(params);
        } else {
          this.location.search('');
        }
      });
  }
}

ResetSearchController.$inject = ['$location', 'savedSearchService', 'filtersService', 'analyticsService'];

const resetSearch = {
  template,
  controller: 'ResetSearchController'
};

export default function (ngModule) {
  ngModule.component('resetSearch', resetSearch);
  ngModule.controller('ResetSearchController', ResetSearchController);
}
